"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Replay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var deleteFile_svg_1 = __importDefault(require("../../../assets/images/deleteFile.svg"));
var common_1 = require("../../../common");
var components_1 = require("../../../common/components");
var ReplayIcon_1 = require("./ReplayIcon");
var styles = __importStar(require("./Replay.module.css"));
var getReplayContent = function (replayMessage) {
    var replayText = replayMessage.text;
    var replayFile = null;
    if (replayMessage.files[0]) {
        var _a = replayMessage.files[0], original_name = _a.original_name, link = _a.link;
        var isImage = (0, common_1.isImageFile)(original_name);
        if (isImage) {
            var imgLink = "".concat(link, "?clientId=").concat(replayMessage.clientId);
            replayFile = (0, jsx_runtime_1.jsx)("img", { src: imgLink, alt: original_name, className: styles.replayImg });
            !replayText && (replayText = original_name);
        }
        if (!isImage && !replayText) {
            replayFile = ((0, jsx_runtime_1.jsx)("div", __assign({ className: styles.replayFile }, { children: (0, jsx_runtime_1.jsx)(components_1.FileIcon, {}) })));
            replayText = (0, common_1.truncateMiddle)(original_name, 23);
        }
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.replayContentWrapper }, { children: [replayFile || null, (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.replayText, style: { maxWidth: "calc(100% - ".concat(replayFile ? '40px' : '0px', ")") } }, { children: replayText }))] })));
};
var Replay = function (_a) {
    var replayMessage = _a.replayMessage, color = _a.color, removeReplay = _a.removeReplay;
    if (!replayMessage)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.replay }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ReplayIcon_1.ReplayIcon, { color: color }), getReplayContent(replayMessage)] }), (0, jsx_runtime_1.jsx)("button", __assign({ className: styles.removeButton, onClick: removeReplay }, { children: (0, jsx_runtime_1.jsx)("img", { src: deleteFile_svg_1.default, alt: 'remove replay', draggable: false }) }))] })));
};
exports.Replay = Replay;
